module.exports = __webpack_public_path__ + "static/media/tabs.93524b29.css";